import { AuszugAtButton } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';



import css from './PurchasableDocument.module.scss';

interface PurchasableDocumentProps
{
  text: string  | React.ReactNode;
  href: string;
}

const PurchasableDocument: React.FC<PurchasableDocumentProps> = (props) =>
{
  const { t } = useTranslation('profiles');
  const { text, href } = props;

  return (
    <li>
      <a
        href={href}
        target="_blank"
        className={css.document}
        rel="noreferrer"
      >
        <span>{text}</span>
        <AuszugAtButton text={t('profiles:actions.buyDocument')} />
      </a>
    </li>
  );
};

export default PurchasableDocument;
